import React from "react";
import { Helmet } from "react-helmet-async";
import { SUPPORTED_LANGS, DEFAULT_LANG } from "../i18n";
import { useLanguage } from "../contexts/LanguageContext";

/**
 * Emits hreflang alternate links for the current page.
 * Uses window.location.origin at runtime so it works across preview & prod.
 * NOTE: Canonical tag is set by each page component (ServiceLandingPage, BlogArticlePage, HomePage)
 * with the correct production URL, not here.
 */
export default function HrefLangTags({ pathSuffix = "" }) {
  const { lang } = useLanguage();
  const origin = typeof window !== "undefined" ? window.location.origin : "";

  return (
    <Helmet>
      <html lang={lang} dir={lang === "ar" ? "rtl" : "ltr"} />
      {SUPPORTED_LANGS.map((l) => (
        <link
          key={l}
          rel="alternate"
          hrefLang={l}
          href={`${origin}/${l}${pathSuffix ? "/" + pathSuffix.replace(/^\//, "") : "/"}`}
        />
      ))}
      <link
        rel="alternate"
        hrefLang="x-default"
        href={`${origin}/${DEFAULT_LANG}${pathSuffix ? "/" + pathSuffix.replace(/^\//, "") : "/"}`}
      />
    </Helmet>
  );
}
